<svg
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M17 17L4 4" stroke="black" stroke-width="1.5" />
  <path d="M17 4L4 17" stroke="black" stroke-width="1.5" />
</svg>
